import React from 'react';
import Appearance from '../EllipseAppearance/EllipseAppearance';
import Conditions from '../ConditionGroup/PropertyConditions';

export default ({ activeTab }) => {
  return (
    <>
      {activeTab === 1 && <Appearance />}
      {activeTab === 3 && <Conditions />}
    </>
  );
};
